import React from 'react';
import { useState } from 'react';
import { ComboFilterCategory } from './ComboFilter';
import { TableSortType } from './Table';
import { ComboFilterHierarchyState } from './ComboFilter';
import { getActiveFilterCount } from './TableUtils';
import { getActiveFilters } from './TableUtils';
import { cloneDeep } from 'lodash';

export const useTableFilters = <ItemType, ColumnKeyType, FilterStateType>(defaultFilterState: FilterStateType) => {
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
  const [hasAnyFilters, setHasAnyFilters] = useState<boolean>(false);
  const [activeFilterCount, setActiveFilterCount] = useState<number>(0);
  const [selectedCategory, setSelectedCategory] = useState<ComboFilterCategory | undefined>(undefined);
  const [sortType, setSortType] = useState<TableSortType<ItemType> | undefined>(undefined);
  const [activeHeading, setActiveHeading] = useState<ColumnKeyType | undefined>(undefined);
  const [isColumnsOpen, setIsColumnsOpen] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<FilterStateType>(defaultFilterState);

  const handleFilterChange = (
    filterComponents: Record<
      string,
      {
        filter: React.ReactNode;
        activeCount: () => number;
        filterCallback: (source: ItemType) => boolean;
        name: string;
      }
    >,
    key: keyof FilterStateType,
    newValue: [number, number] | [Date, Date] | string[] | ComboFilterHierarchyState
  ) => {
    const newFilterState = { ...filterState, [key]: newValue };
    const activeFilters = getActiveFilters(defaultFilterState, newFilterState);
    const numActive = getActiveFilterCount(defaultFilterState, newFilterState);

    setHasAnyFilters(activeFilters);
    setActiveFilterCount(numActive);
    setFilterState(newFilterState);
  };

  const onSearchInputChange = (query: string) => {
    setSearchQuery(query);
  };

  const handleResetFilters = () => {
    const newFilterState = cloneDeep(defaultFilterState);
    setHasAnyFilters(false);
    setActiveFilterCount(0);
    setFilterState(newFilterState);
    setSearchQuery('');
  };

  return {
    searchQuery,
    setSearchQuery,
    hasAnyFilters,
    setHasAnyFilters,
    activeFilterCount,
    setActiveFilterCount,
    selectedCategory,
    setSelectedCategory,
    sortType,
    setSortType,
    activeHeading,
    setActiveHeading,
    isColumnsOpen,
    setIsColumnsOpen,
    filterState,
    setFilterState,
    onSearchInputChange,
    handleResetFilters,
    handleFilterChange,
  };
};
